/**
  * Open Modal javscript trigger
  *
  * */
function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

function updateCartCountInHeader(){
  const desktopCartCount = document.querySelector(`#cart-icon-desktop .cart-count`);
  const mobileCartCount = document.querySelector(`#cart-icon-mobile .cart-count`);

  if (desktopCartCount) {
    desktopCartCount.innerHTML = window.globalSpace.cart.item_count;
    desktopCartCount?.classList.toggle('d-none', window.globalSpace.cart.item_count === 0);
  }
  if (mobileCartCount) {
    mobileCartCount.innerHTML = window.globalSpace.cart.item_count;
    mobileCartCount?.classList.toggle('d-none', window.globalSpace.cart.item_count === 0);
  }
}

// absolute header height

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper");

  if (header) {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty("--header-height", headerHeight + "px");
  }
});
  window.addEventListener("resize", function () {
  const header = document.querySelector(".header-wrapper");
    if (header) {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty("--header-height", headerHeight + "px");
  }
});

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "touchend", "mouseenter", "mouseleave", "focusout"];

    // NEW: Timers to manage the delay
    this.openTimer = null;
    this.closeTimer = null;
    this.delayDuration = 200;

    this.init();
  }

  init() {
    // Check if device supports hover (desktop) - used to determine click behavior
    const supportsHover = window.matchMedia('(hover: hover)').matches;
    
    this.supportedEvents.forEach((type) => {
      if (type === 'click' || type === 'touchend') {
        this.toggleCTA.addEventListener(type, (evt) => {
          clearTimeout(this.openTimer);
          clearTimeout(this.closeTimer);
          // Get the href of the toggle link
          const href = this.toggleCTA.getAttribute('href');
          const hasValidLink = href && href !== '#' && href !== '' && !href.startsWith('javascript:');
          
          // On desktop with hover support: if link has a valid URL, allow navigation
          // The dropdown is already shown via mouseenter, so clicking should navigate
          if (supportsHover && hasValidLink && type === 'click') {
            // Allow default navigation - don't prevent default
            return;
          }
          if (evt.target.tagName.toLowerCase() === 'span') {
            return;
          }else{
            evt.preventDefault();
            evt.stopPropagation();
            this.toggleDropdown();
          }
        });
      } else if(type === 'mouseenter') {
        this.toggleCTA.addEventListener(type, (evt) => {
          // Clear any pending close timer
          clearTimeout(this.closeTimer);

          this.openTimer = setTimeout(() => {
          
            // 1. FORCE CLOSE ALL OTHER OPEN DROPDOWNS
            // (Adjust '.is-open' and '.is-active' below if your theme uses different class names like '.show' or '.active')
            document.querySelectorAll('.dropdown.open').forEach((openMenu) => {
              if (openMenu !== this.dropdown) {
                openMenu.classList.remove('open'); // Hide the other dropdowns
              }
            });
            
            // Also reset the toggle buttons for those closed dropdowns
            document.querySelectorAll('.dropdown-toggle').forEach((toggle) => {
              if (toggle !== this.toggleCTA) {              
                toggle.setAttribute('aria-expanded', 'false');
              }
            });
              
          
            if (!this.dropdown.classList.contains('open')) {
              this.toggleDropdown();
            }
          }, 200); // 200ms delay
        });
      } else if(type === 'mouseleave') {
        // Triggered when leaving the ENTIRE dropdown (parent LI)
        this.dropdown.addEventListener(type, (evt) => {
          clearTimeout(this.openTimer);
          // Set a delay before closing so the user can move the mouse into the menu
          this.closeTimer = setTimeout(() => {
            // FIX: Changed 'is-open' to 'open' to match the rest of your code
            if (this.dropdown.classList.contains('open')) {
              // FIX: Explicitly call hide instead of toggle to guarantee it closes
              this.dropdownHide(this.dropdown);
            }
          }, 300);
        });
      } else if(type == 'focusout'){
        this.dropdown.addEventListener(type, (evt) => {
          if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
            this.dropdownHide(this.dropdown);
          }
        });
      }
    });

    this.bindEvents();
  }

  bindEvents(){
    const closeBtn = this.dropdown.querySelector('.slideout-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.dropdownToggle(this.dropdown);
      });
    }
    // OPTIONAL: Ensure hovering the dropdown content keeps it open
    // (Helps if there is a tiny physical gap between link and menu)
    const menuContent = this.dropdown.querySelector('.dropdown-menu');
    if(menuContent) {
        menuContent.addEventListener('mouseenter', () => {
            clearTimeout(this.closeTimer);
        });
    }
  }

  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    
    // Safety check: clear any pending close timers
    clearTimeout(this.closeTimer);

    this.toggleCTA.setAttribute('aria-expanded', true);
    dropdownParent.classList.add('open');
  }

  dropdownHide(dropdownParent) {
    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = document.querySelector('#site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if(closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));
  
    SiteOverlay.hideOverlay();
  }

  /**
   * Show Overlay
   */
   static showOverlay(){
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', false);
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay
   */
  static hideOverlay(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-fixed');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';
    
    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.querySelector('[data-trigger-video]') || this.container.querySelector('[data-trigger-video]');

  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-poster-video]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true') {
      // Check if it's in a swiper slide
      const swiperSlide = this.closest('swiper-slide');
      if(swiperSlide) {
        // For swiper slides, check if it's the active slide
        this.handleSwiperAutoplay(swiperSlide);
      } else {
        // For regular grid placement, use intersection observer
        this.autoplayOnInit();
      }
    }
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    const isPopup = this.placementType === 'popup';
    
    if (this.videoStatus === 'empty' || isPopup) {
      // Clear existing content for popup to ensure single video instance
      if (isPopup) {
        this.videoSection.innerHTML = '';
      }
      
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video-' + Date.now();
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        if (isPopup) {
          openModal(this.videoModal, this.triggerVideo);
        } else {
          this.container.classList.add('playing--video');
        }
        this.videoSection.setAttribute('aria-hidden', 'false');
        if (this.dataset.controls === 'true') {
          this.pauseOnVisibilityChange(videoElement);
        }
      }, 500);
    } else {
      const videoElement = this.querySelector('.video-section video, .video-section iframe');
      this.container.classList.add('playing--video');
      this._playVideo(videoElement);
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          // Handle play() interruption or other errors silently
          if (error.name !== 'AbortError') {
            console.warn('Video play failed:', error);
          }
        });
      }
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  _pauseVideo(video) {
    if (this.type === 'local') {
      video.pause();
    } else if (this.type === 'youtube') {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      video.autoplay = true;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${this.dataset.muted == 'true' ? 1 : 0}&controls=${this.dataset.controls == 'true' ? 1 : 0}&loop=${this.dataset.loop == 'true' ? 1 : 0}&enablejsapi=1&origin=${window.origin}` );
      // &playlist=${videoID}
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    this.scrollObserver = new IntersectionObserver((entries) => { 
      if(videoEle == undefined || videoEle.contentWindow == null){
        this.scrollObserver.disconnect();
        return;
      }

      if(!entries[0].isIntersecting){
        this._pauseVideo(videoEle)
      }
    });
    this.scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    const posterVideo = this.querySelector('[data-poster-video]');
    if(!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  autoplayOnInit(element = this){
    const elementIntersection = (entries) => {
      if(entries[0].isIntersecting && entries[0].intersectionRatio > 0){
        element.toggleView();
        observeElement.disconnect();
      }
    };
    let observeElement = new IntersectionObserver(elementIntersection);
    observeElement.observe(element);
  }

  handleSwiperAutoplay(swiperSlide) {
    // Check if this slide is currently active
    if(swiperSlide.classList.contains('swiper-slide-active')) {
      // Start autoplay immediately for active slide
      this.toggleView();
    } else {
      // Listen for slide change events
      const swiper = swiperSlide.closest('swiper-container') || swiperSlide.closest('.swiper');
      if(swiper) {
        const checkActiveSlide = () => {
          if(swiperSlide.classList.contains('swiper-slide-active')) {
            this.toggleView();
            // Remove listener after autoplay starts
            swiper.removeEventListener('slideChange', checkActiveSlide);
          }
        };
        
        // Listen for swiper slide change events
        swiper.addEventListener('slideChange', checkActiveSlide);
        
        // Also check with MutationObserver for class changes
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if(swiperSlide.classList.contains('swiper-slide-active')) {
                this.toggleView();
                observer.disconnect();
              }
            }
          });
        });
        
        observer.observe(swiperSlide, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }
  }
}
customElements.define("custom-video", CustomVideo);

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.isOpen = false;

    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.isOpen = true;
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);

    SiteOverlay.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.isOpen = false;
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    SiteOverlay.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video') this.querySelector('.video-container').innerHTML = '';
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = document.querySelector('toast-notification');

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"], a[href="#${this.id}"]`);
      this.closeButtons = this.querySelectorAll('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele')
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(event) {
    if(event.code == undefined || event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');

    SiteOverlay.showOverlay();
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);

    this.openedBy?.setAttribute('aria-expanded', true);
  }

  closeDrawer() {
      this.isOpen = false;
      this.classList.remove('open');
      this.setAttribute('aria-hidden', 'true');

      SiteOverlay.hideOverlay();
      this.hideOpenPanels();
      if(this.id == 'quickshop-drawer') this.querySelector('[data-quickshop-body]').innerHTML = '';

      this.openedBy?.setAttribute('aria-expanded', false);
      Utility.removeTrapFocus(this.openedBy);
      this.openedBy = null;
  }

  resetOtherDrawers(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
  }

  hideOpenPanels(){
    let openPanels = this.querySelectorAll('[is="collapsiblePanel"].open');
    openPanels.forEach(panel => panel.querySelector('[data-toggle="panel"]').click());

    let openDropdowns = Array.from(this.querySelectorAll('[is="drop-down"].open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele.querySelector('[data-toggle="open"]')?.setAttribute('aria-expanded', false);
    });
  }
}
customElements.define('custom-drawer', CustomDrawer);

const swiperSliders = document.querySelectorAll('swiper-container');
swiperSliders.forEach(swiperEle => {
  swiperEle.addEventListener('swiperslidechange', (event) => {
    const index = event.detail[0].activeIndex;
    const swipDirection = event.detail[0].swipeDirection;
    const prevSlide = swiperEle.querySelector(`swiper-slide[data-index="${swipDirection == 'prev' ? index+2 : index}"]`);
    const activeSlide = swiperEle.querySelector(`swiper-slide[data-index="${index+1}"]`);

    // Pause previous slide video if available
    if(prevSlide && prevSlide.querySelector('.custom-video-container.playing--video')){
      let customElement = prevSlide.querySelector('custom-video');
      let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
      if(videoEle && customElement.dataset.controls == 'true') {
        customElement._pauseVideo(videoEle);
      }
    }

    // Play active slide video if available
    if(prevSlide && activeSlide.querySelector('.custom-video-container')){
      let customElement = activeSlide.querySelector('custom-video');
      if(customElement.videoStatus == 'empty'){
        customElement.toggleView();
      }else{
        let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
        if(videoEle) customElement._playVideo(videoEle);
      }
    }
  });
});

// Remove aria-controls from swiper navigation buttons to fix accessibility issues
// Swiper library sometimes adds dynamic aria-controls attributes that cause validation errors
function removeSwiperAriaControls() {
  const swiperButtons = document.querySelectorAll('.swiper-button-prev[aria-controls], .swiper-button-next[aria-controls]');
  swiperButtons.forEach(button => {
    button.removeAttribute('aria-controls');
  });
  return swiperButtons.length;
}

// Fix NaN aria-labels in swiper containers
// Swiper library sometimes sets aria-label="NaN / X" when realIndex is not properly initialized
function fixSwiperNaNAriaLabels() {
  const swiperContainers = document.querySelectorAll('swiper-container[aria-label*="NaN"]');
  swiperContainers.forEach(container => {
    const currentLabel = container.getAttribute('aria-label');
    if (currentLabel && currentLabel.includes('NaN')) {
      // Extract the total count from the label (e.g., "NaN / 4" -> 4)
      const match = currentLabel.match(/NaN\s*\/\s*(\d+)/);
      const totalSlides = match ? match[1] : '';
      // Fix the aria-label to show "1 / X" as the default starting position
      const newLabel = totalSlides ? `1 / ${totalSlides}` : 'Image gallery';
      container.setAttribute('aria-label', newLabel);
    }
  });
  return swiperContainers.length;
}

// Run immediately on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    removeSwiperAriaControls();
    // Delay slightly to allow Swiper to initialize
    setTimeout(fixSwiperNaNAriaLabels, 100);
  });
} else {
  removeSwiperAriaControls();
  // Delay slightly to allow Swiper to initialize
  setTimeout(fixSwiperNaNAriaLabels, 100);
}

// Fix loop navigation and pagination bullets for mobile devices
function fixLoopNavigation() {
  const prevButtons = document.querySelectorAll('.swiper-button-prev');
  const nextButtons = document.querySelectorAll('.swiper-button-next');
  
  // Store the index before navigation for each swiper
  const swiperIndexBeforeNav = new WeakMap();
  
  // Capture index BEFORE click propagates to Swiper
  function captureIndexBeforeNav(button) {
    const wrapper = button.closest('.swiper-wrapper__custom');
    if (!wrapper) return;
    
    const swiperContainer = wrapper.querySelector('swiper-container');
    const pagination = wrapper.querySelector('.swiper-pagination');
    
    if (swiperContainer && swiperContainer.swiper) {
      const swiper = swiperContainer.swiper;
      let currentIndex = swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
      
      // If Swiper returns NaN or invalid, use the active bullet as fallback
      if (isNaN(currentIndex) || currentIndex < 0) {
        if (pagination) {
          const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
          currentIndex = Array.from(bullets).findIndex(b => b.classList.contains('swiper-pagination-bullet-active'));
          if (currentIndex === -1) currentIndex = 0;
        } else {
          currentIndex = 0;
        }
      }
      
      swiperIndexBeforeNav.set(swiperContainer, currentIndex);
    }
  }
  
  // Handle manual navigation buttons
  function handleNavigation(button, direction) {
    const wrapper = button.closest('.swiper-wrapper__custom');
    if (!wrapper) return;
    
    const swiperContainer = wrapper.querySelector('swiper-container');
    const pagination = wrapper.querySelector('.swiper-pagination');
    
    if (swiperContainer && swiperContainer.swiper && pagination) {
      const swiper = swiperContainer.swiper;
      const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
      const totalSlides = bullets.length;
      
      if (totalSlides === 0) return;
      
      // Get the index we captured before the click
      const indexBeforeNav = swiperIndexBeforeNav.get(swiperContainer);
      
      // Also get current active bullet as fallback
      const activeBulletIndex = Array.from(bullets).findIndex(b => b.classList.contains('swiper-pagination-bullet-active'));
      
      // Use captured index only if it's a valid number (not NaN, not undefined)
      const effectiveIndexBefore = (typeof indexBeforeNav === 'number' && !isNaN(indexBeforeNav)) 
        ? indexBeforeNav 
        : (activeBulletIndex >= 0 ? activeBulletIndex : 0);
      
      // Wait for Swiper to complete its native navigation
      setTimeout(() => {
        let currentIndex = swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
        
        // Handle NaN - use activeBulletIndex as fallback
        if (isNaN(currentIndex)) {
          currentIndex = activeBulletIndex >= 0 ? activeBulletIndex : 0;
        }
        
        let targetIndex = currentIndex;
        
        // Check if Swiper's native loop failed and we need to manually loop
        if (direction === 'next') {
          if (effectiveIndexBefore === totalSlides - 1 && currentIndex >= totalSlides - 1) {
            targetIndex = 0;
            try { swiper.slideTo(0, 300); } catch (e) { /* Silent fail */ }
          }
        } else if (direction === 'prev') {
          if (effectiveIndexBefore === 0 && (currentIndex <= 0 || isNaN(currentIndex))) {
            targetIndex = totalSlides - 1;
            try { swiper.slideTo(totalSlides - 1, 300); } catch (e) { /* Silent fail */ }
          }
        }
        
        // Ensure the target index is within bounds
        if (isNaN(targetIndex) || targetIndex < 0) targetIndex = 0;
        if (targetIndex >= totalSlides) targetIndex = totalSlides - 1;
        
        // Update pagination bullets to match the target slide
        bullets.forEach((bullet, index) => {
          if (index === targetIndex) {
            bullet.classList.add('swiper-pagination-bullet-active');
          } else {
            bullet.classList.remove('swiper-pagination-bullet-active');
          }
        });
        
      }, 100);
    }
  }
  
  // Handle auto-playing swipers (like testimonials)
  function fixAutoSwiperPagination() {
    // Find auto-playing swipers with loop mode
    const selectors = [
      'swiper-container[autoplay][loop="true"]',
      'swiper-container[autoplay]',
      'swiper-container[loop="true"]'
    ];
    
    let foundSwipers = [];
    selectors.forEach(selector => {
      const swipers = document.querySelectorAll(selector);
      foundSwipers = [...foundSwipers, ...Array.from(swipers)];
    });
    
    // Remove duplicates
    const uniqueSwipers = [...new Set(foundSwipers)];
    
    uniqueSwipers.forEach((swiperContainer) => {
      if (!swiperContainer.swiper) return;
      
      const swiper = swiperContainer.swiper;
      
      // Only handle main content swipers, not thumbs swipers
      const isThumbsSwiper = swiperContainer.id.includes('thumbs-') || 
                            swiperContainer.className.includes('thumb');
      
      if (isThumbsSwiper) return;
      
      // Find pagination element
      let pagination = null;
      
      // Method 1: In wrapper
      const wrapper = swiperContainer.closest('.swiper-wrapper__custom');
      if (wrapper) {
        pagination = wrapper.querySelector('.swiper-pagination');
      }
      
      // Method 2: In parent section
      if (!pagination) {
        const section = swiperContainer.closest('section');
        if (section) {
          pagination = section.querySelector('.swiper-pagination');
        }
      }
      
      // Method 3: Try specific class names
      if (!pagination) {
        const specificSelectors = ['.swiper-pagination-main-tm', '.swiper-pagination-bullets'];
        for (const sel of specificSelectors) {
          const parent = swiperContainer.closest('section') || document;
          pagination = parent.querySelector(sel);
          if (pagination) break;
        }
      }
      
      if (pagination) {
        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
        
        if (bullets.length > 0) {
          const updatePagination = () => {
            let realIndex = swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
            const totalSlides = bullets.length;
            
            // Handle invalid values - clamp to valid range
            if (isNaN(realIndex) || realIndex < 0) {
              realIndex = 0;
            } else if (realIndex >= totalSlides) {
              realIndex = totalSlides - 1;
            }
            
            // Update pagination bullets to match current slide
            bullets.forEach((bullet, bulletIndex) => {
              if (bulletIndex === realIndex) {
                bullet.classList.add('swiper-pagination-bullet-active');
              } else {
                bullet.classList.remove('swiper-pagination-bullet-active');
              }
            });
          };
          
          // Listen to swiper events
          try {
            swiper.on('slideChange', updatePagination);
            swiper.on('realIndexChange', updatePagination);
          } catch (error) {
            // Silent error handling for production
          }
        }
      }
    });
  }
  
  // Add event listeners for manual navigation buttons
  // Use capturing phase (true) to capture index BEFORE Swiper handles the click
  prevButtons.forEach((button) => {
    try {
      // Capture index in capturing phase (runs first)
      button.addEventListener('mousedown', () => captureIndexBeforeNav(button), true);
      button.addEventListener('touchstart', () => captureIndexBeforeNav(button), true);
      // Handle navigation in bubbling phase (runs after Swiper)
      button.addEventListener('click', () => handleNavigation(button, 'prev'));
    } catch (error) {
      // Silently handle any errors to prevent breaking other functionality
    }
  });
  
  nextButtons.forEach((button) => {
    try {
      // Capture index in capturing phase (runs first)
      button.addEventListener('mousedown', () => captureIndexBeforeNav(button), true);
      button.addEventListener('touchstart', () => captureIndexBeforeNav(button), true);
      // Handle navigation in bubbling phase (runs after Swiper)
      button.addEventListener('click', () => handleNavigation(button, 'next'));
    } catch (error) {
      // Silently handle any errors to prevent breaking other functionality
    }
  });
  
  // Fix auto-playing swipers
  fixAutoSwiperPagination();
}

// Initialize loop navigation fix
function initLoopNavigationFix() {
  // Initial setup
  setTimeout(fixLoopNavigation, 500);
  
  // Re-run when new content is dynamically loaded
  const observer = new MutationObserver((mutations) => {
    let shouldReinit = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && 
              (node.tagName === 'SWIPER-CONTAINER' || 
               node.querySelector && node.querySelector('swiper-container'))) {
            shouldReinit = true;
          }
        });
      }
    });
    
    if (shouldReinit) {
      setTimeout(fixLoopNavigation, 200);
      // Also fix any NaN aria-labels in newly added swipers
      setTimeout(fixSwiperNaNAriaLabels, 300);
    }
  });
  
  // Also observe for attribute changes to catch NaN aria-labels being set
  const ariaObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'aria-label' &&
          mutation.target.tagName === 'SWIPER-CONTAINER') {
        const label = mutation.target.getAttribute('aria-label');
        if (label && label.includes('NaN')) {
          setTimeout(fixSwiperNaNAriaLabels, 50);
        }
      }
    });
  });
  
  ariaObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-label'],
    subtree: true
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoopNavigationFix);
} else {
  initLoopNavigationFix();
}

// Use interval to check and remove aria-controls periodically
// This catches attributes added dynamically by Swiper after initialization
let intervalCount = 0;
const maxIntervalChecks = 20; // Stop after 20 checks (10 seconds if interval is 500ms)
const ariaControlsInterval = setInterval(() => {
  const removedCount = removeSwiperAriaControls();
  intervalCount++;
  
  // Stop interval if we've checked enough times or no more buttons with aria-controls found
  if (intervalCount >= maxIntervalChecks || removedCount === 0) {
    clearInterval(ariaControlsInterval);
  }
}, 500); // Check every 500ms

document.addEventListener('DOMContentLoaded', () => {
  // 1. Select all the parent links in the mobile navbar that have dropdowns
  const mobileDropdownLinks = document.querySelectorAll('.navbar-mobile .nav-item.dropdown .dropdown-toggle');

  mobileDropdownLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      
      // 2. Check if the user clicked the text/link, rather than the SVG itself
      if (!e.target.closest('svg')) {
        
        // 3. Stop the browser from navigating to the href URL
        e.preventDefault(); 
        
        // 4. Find the SVG arrow inside this specific link and trigger a click on it
        const arrow = this.querySelector('svg');
        if (arrow) {
          // Dispatches a click to the SVG so your existing menu script takes over
          arrow.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        }
      }
    });
  });
});